import React, { useState, useEffect } from 'react';
import { Layout, QRCode, Spin, Empty, Flex } from 'antd';
import { WechatOutlined } from '@ant-design/icons';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import unit from './unit';
import './App.css';
import { color } from 'echarts';

// 意见反馈页面新信息配置
const metaConfig = {
  title: '意见反馈-cangweizaixian.com',
  keywords: '意见反馈,和讯-博弈大师,微信关注',
  description: '您的每一个建议，都是让我们变得更好的动力～ 无论遇到bug、还是有功能想法，或是对内容有吐槽，都欢迎告诉我们。微信扫描左侧二维码，关注客服微信，把您宝贵意见直接反馈给他'
};

const { Content } = Layout;

const Feedback = () => {
  const [adData, setAdData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 设置页面元信息
    document.title = metaConfig.title;
    document.querySelector('meta[name="keywords"]').setAttribute('content', metaConfig.keywords);
    document.querySelector('meta[name="description"]').setAttribute('content', metaConfig.description);
    
    unit.httpGet('/pc/gudong/ad', {}, (data) => {
      if (data?.show) setAdData(data);
      setLoading(false);
    }, () => setLoading(false));
  }, []);

  return (
    <div className="App">
      <Flex gap="middle" wrap>
        <Layout style={{ minHeight: '100vh' }}>
            <HeaderComponent />
            <Content className="fb-content">
            {loading ? (
                <Spin size="large" tip="正在加载二维码..." />
            ) : adData?.qrcode_url ? (
                <div className="feedback-wrapper">
                    {/* 左侧二维码块 */}
                    <div className="qr-box">
                        <QRCode value={adData.qrcode_url} size={200} />
                        <div className="wx-tip">
                        <WechatOutlined />
                        <span>微信扫描关注</span>
                        </div>
                    </div>

                    {/* 右侧文字块 */}
                    <div className="fb-right">
                        <h2 className="fb-title">意见反馈</h2>
                        <p className="fb-desc">
                            您的每一个建议，都是让我们变得更好的动力～<br />
                            无论遇到 bug、还是有功能想法，或是对内容有吐槽，都欢迎告诉我们。<br />
                            微信扫描左侧二维码，关注客服微信，把您宝贵意见直接反馈给他
                        </p>
                        <p className="fb-contact">
                            操作提示：①未关注：直接扫描关注，②已关注：前往微信“<span style={{ color:"#F23031" }}>通讯录-&gt;企业微信联系人</span>”找到和讯-博弈大师助理
                        </p>
                    </div>
                </div>
            ) : (
                <Empty description="暂无二维码" />
            )}
            </Content>
            <FooterComponent />
        </Layout>
      </Flex>
    </div>
  );
};

export default Feedback;